import { ISampleReport } from './ReportCard';

export const SAMPLE_REPORTS: ISampleReport[] = [
  {
    id: '1',
    title: 'P1_Bass-Strait',
    thumbnailUrl:
      'static/media/samples/P1_Bass-Strait/P1_Bass-Strait_cover.jpg',
    zipUrl: 'static/media/samples/P1_Bass-Strait/P1_Bass-Strait.zip',
    pdfUrl:
      'static/media/samples/P1_Bass-Strait/P9_146.198_-39.905_81_1979-01-01_2018-12-31.pdf',
  },
  {
    id: '2',
    title: 'P1_Brazil-South',
    thumbnailUrl:
      'static/media/samples/P1_Brazil-South/P1_Brazil-South_cover.jpg',
    zipUrl: 'static/media/samples/P1_Brazil-South/P1_Brazil-South.zip',
    pdfUrl:
      'static/media/samples/P1_Brazil-South/P1_-45.97525_-24.60312_62.2_1993-01-01_2023-12-31.pdf',
  },
  {
    id: '3',
    title: 'P1_North-Sea',
    thumbnailUrl: 'static/media/samples/P1_North-Sea/North-Sea_cover.jpg',
    zipUrl: 'static/media/samples/P1_North-Sea/North-Sea.zip',
    pdfUrl:
      'static/media/samples/P1_North-Sea/P1_1.602375_59.180237_113.9_1979-01-15_2024-06-01.pdf',
  },
  {
    id: '4',
    title: 'P1_SouthKorea',
    thumbnailUrl: 'static/media/samples/P1_SouthKorea/SouthKorea_cover.jpg',
    zipUrl: 'static/media/samples/P1_SouthKorea/South_Korea.zip',
    pdfUrl:
      'static/media/samples/P1_SouthKorea/P1_127.937515_34.011787_84.7_1979-01-01_2025-10-01.pdf',
  },
  {
    id: '5',
    title: 'P1_US_EastCoast',
    thumbnailUrl: 'static/media/samples/P1_US_EastCoast/US_EastCoast_cover.jpg',
    zipUrl: 'static/media/samples/P1_US_EastCoast/US_EastCoast.zip',
    pdfUrl:
      'static/media/samples/P1_US_EastCoast/P1_-78.81326_32.97595_25.0_1979-01-01_2025-10-01.pdf',
  },
];
